export default {"src":"/_next/static/media/check.7deed06c.svg","height":25,"width":24};